import he from 'he';

export function decodeTweetText(tweetText) {
  return he.decode(tweetText);
}
